module.exports = __webpack_public_path__ + "static/img/award6.61251a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/award6.png
// module id = vNQ9
// module chunks = 0